module.exports = __webpack_public_path__ + "static/media/12.5075c0ce.jpg";